import React, { useState } from "react";

import type ComplexPromotionLevelModel from "@admin/domain/complexPromotions/models/ComplexPromotionLevelModel";
import Input from "@admin/components/Input";
import RadioButton from "@admin/components/RadioButton";

type Requirements = ComplexPromotionLevelModel[`promocode_requirements`];

type Props = {
    levelIndex: number;
    level: ComplexPromotionLevelModel;
};

const PromoCodeRequirements: React.FC<Props> = ({ levelIndex, level }) => {
    const [requirements, setRequirements] = useState<Requirements>(level.promocode_requirements);

    const add = (): void =>
        setRequirements([
            ...requirements,
            {
                quantity: 1,
                id: 0,
                promocode_title: ``,
            },
        ]);

    const remove = (promoCodeIndex: number): void =>
        setRequirements(requirements.filter((_, itemIndex: number): boolean => promoCodeIndex !== itemIndex));

    return (
        <div className="rounded border p-10 my-5">
            <h2>Промокоды в корзине</h2>

            {requirements.length > 1 ? (
                <div className="my-5">
                    <RadioButton
                        name="condition"
                        value="every"
                        label="Все промокоды"
                        defaultChecked={level?.condition !== `any`}
                    />

                    <RadioButton
                        name="condition"
                        value="any"
                        label="Любой из промокодов"
                        defaultChecked={level?.condition === `any`}
                    />
                </div>
            ) : (
                <input type="hidden" name="condition" value="every" />
            )}

            {requirements.map((requirement, index) => (
                <div key={requirement.id || `new-requirement-${index}`} className="rounded border p-6 my-5">
                    {requirement.id && (
                        <input
                            type="hidden"
                            name={`levels[${levelIndex}][promocode_requirements][${index}][id]`}
                            value={requirement.id}
                        />
                    )}

                    <Input
                        label="Промокод"
                        name={`levels[${levelIndex}][promocode_requirements][${index}][promocode_title]`}
                        defaultValue={requirement.promocode_title}
                    />

                    {requirements.length > 1 && (
                        <button
                            type="button"
                            className="btn btn-danger btn-sm me-2 mt-5"
                            onClick={(): void => remove(index)}
                        >
                            Удалить
                        </button>
                    )}
                </div>
            ))}

            <button type="button" className="btn btn-primary me-2 mt-5" onClick={add}>
                Добавить промокод
            </button>
        </div>
    );
};

export default PromoCodeRequirements;
